import { fromNullable } from 'fp-ts/lib/Option';
import * as proj from 'ol/proj';
// import { openTagsEditor } from 'qa/src/events/app';
// import { initTagForm } from 'qa/src/events/osm';
import { DiffEntry, diffTags } from 'qa/src/queries/osm';
import {
    // getOsmObjectForIssue,
    getOsmResourceId,
    getOsmObjectRemote,
    OsmResourceId,
    getPreviousOsmObjectRemote,
    getOrigin,
} from 'qa/src/queries/qa';
import { Issue, OsmObject, getElement } from 'qa/src/remote';
import { DIV, SPAN, A, NodeOrOptional } from 'sdi/components/elements';
import { scopeOption } from 'sdi/lib';
import tr from 'sdi/locale';
import { remoteToOption, RemoteResource, foldRemote } from 'sdi/source';
import { mapCollectionC } from 'sdi/util';
import debug = require('debug');
// import { renderButtonEditTags } from '../buttons';
import { noView } from '.';
import { getThemeObject, withMapCompleteTheme } from 'qa/src/queries/app';

const logger = debug('client:issue-info');

const renderOsmRemoteLoading = () =>
    DIV({ className: `issue-field tags` }, 'Chargement des données...');

const renderOsmRemoteError = (err: string) =>
    DIV({ className: `issue-field tags` }, `Erreur de chargement ${err}`);

const renderTag = (k: string, v: string) =>
    DIV(
        { className: 'tag' },
        DIV({ className: 'key' }, k),
        DIV({ className: 'value' }, v)
        // `${k}=${v}; `
    );

const renderDiffedTag = (previousValue: string, entry: DiffEntry) => {
    switch (entry.op) {
        case 'create':
            return DIV(
                { className: 'tag tag-create', title: 'création de tag' },
                DIV({ className: 'key' }, entry.key),
                DIV({ className: 'previous-value' }, previousValue),
                DIV({ className: 'value' }, entry.value)
            );
        case 'delete':
            return DIV(
                { className: 'tag tag-delete', title: 'suppression de tag' },
                DIV({ className: 'key' }, entry.key),
                DIV({ className: 'previous-value' }, previousValue),
                DIV({ className: 'value' }, entry.value)
            );
        case 'modify':
            return DIV(
                {
                    className: 'tag tag-modify',
                    title: 'modification de valeur',
                },
                DIV({ className: 'key' }, entry.key),
                DIV({ className: 'previous-value' }, previousValue),
                DIV(
                    { className: 'value' },
                    // DIV({ className: 'old-value' }, entry.oldValue),
                    // DIV({ className: 'new-value' }, entry.value),
                    ...entry.diff.map(([op, value]) => {
                        switch (op) {
                            case 'id':
                                return SPAN(
                                    { className: 'word op-id' },
                                    `${value} `
                                );
                            case 'add':
                                return SPAN(
                                    { className: 'word op-add' },
                                    `${value} `
                                );
                            case 'del':
                                return SPAN(
                                    { className: 'word op-del' },
                                    `${value} `
                                );
                        }
                    })
                )
            );
        case 'none':
            return DIV(
                { className: 'tag tag-id' },
                DIV({ className: 'key' }, entry.key),
                DIV({ className: 'previous-value' }, previousValue),
                DIV({ className: 'value' }, entry.value)
            );
    }
};

const tagDiffsTitle = () =>
    DIV(
        { className: 'tag diff-title' },
        DIV({ className: 'key' }, 'Version'),
        DIV({ className: 'previous-value' }, 'Ancienne'),
        DIV({ className: 'value' }, 'Nouvelle')
    );

// const renderTagActions = (i: Issue) =>
//     DIV({ className: `issue-field tags-actions` },
//         DIV({ className: 'issue-field-label' }, tr.qa('__empty__')),
//         DIV({ className: 'issue-field-value' },
//             DIV({ className: 'value link edit-tag' },
//                 SPAN(
//                     {
//                         onClick: () => getOsmObjectForIssue(i).map((e) => { initTagForm(e, i.id); openTagsEditor(); }),
//                     },
//                     tr.qa('editTags'))),
//         ),
//     );

// const renderTagActions = (i: Issue) =>
//     DIV(
//         { className: `issue-field tags-actions` },
//         renderButtonEditTags(() =>
//             getOsmObjectForIssue(i).map(e => {
//                 initTagForm(e, i.id);
//                 openTagsEditor();
//             })
//         )
//     );

const renderTagList = (i: Issue) =>
    DIV(
        { className: `issue-field tags` },
        DIV({ className: 'issue-field-label' }, 'Tags'),
        scopeOption()
            .let('rid', getOsmResourceId(i))
            .let('resource', ({ rid }) => getOsmObjectRemote(rid))
            .map(({ rid, resource }) => renderOsmRemote(rid, resource, i))
    );

const getiDurl = (issue: Issue) => {
    const obj = fromNullable(issue.osm_id);
    const type = fromNullable(issue.osm_type);
    const [lon, lat] = issue.point.coordinates;
    return scopeOption()
        .let('id', obj)
        .let('type', type)
        .map(
            ({ id, type }) =>
                `https://www.openstreetmap.org/edit?editor=id&${type}=${id}#map=18/${lat}/${lon}`
        );
};

const getJOSMurl = (issue: Issue) => {
    const obj = fromNullable(issue.osm_id);
    const type = fromNullable(issue.osm_type);
    const latBuf = 0.001;
    const lonBuf = 0.004;
    const [lon, lat] = issue.point.coordinates;
    return scopeOption()
        .let('id', obj)
        .let('type', type)
        .map(
            ({ id, type }) =>
                `http://localhost:8111/load_and_zoom?left=${
                    lon - lonBuf
                }&bottom=${lat - latBuf}&right=${lon + lonBuf}&top=${
                    lat + latBuf
                }&select=${type}${id}`
        );
};

const getMapCompleteUrl = (issue: Issue) => {
    const obj = fromNullable(issue.osm_id);
    const type = fromNullable(issue.osm_type);
    const mapCompleteTheme = getThemeObject().map(t => t?.map_complete_theme);
    const [lat, lon] = issue.point.coordinates;
    return scopeOption()
        .let('id', obj)
        .let('type', type)
        .let('theme', mapCompleteTheme)
        .map(
            ({ id, type, theme }) =>
                `https://mapcomplete.org/${theme}.html?z=18&lat=${lat}&lon=${lon}#${type}/${id}`
        );
};

export const getLatLonCoord = (coordinates: number[]): [number, number] => {
    const x = coordinates[0];
    const y = coordinates[1];
    const coordLonLat = proj.toLonLat([x, y]);
    const lon = coordLonLat[0];
    const lat = coordLonLat[1];
    return [lat, lon];
};

const renderEditLinkList = (issue: Issue) => {
    const coordinates = issue.point.coordinates;

    if (coordinates.length === 2) {
        // const [lat, lon] = getLatLonCoord(coordinates);
        return [
            // SPAN(
            //     {},
            //     A(
            //         {
            //             className: 'link-qa osminedit',
            //             href: `https://osminedit.pavie.info/#18/${lat}/${lon}`,
            //             target: '_blank',
            //         },
            //         'osmInEdit'
            //     )
            // ), // todo? zoom level as variable?
            SPAN(
                {},
                getiDurl(issue).map(url =>
                    A(
                        {
                            className: 'link-qa iD',
                            href: url,
                            target: '_blank',
                        },
                        'iD'
                    )
                )
            ),
            SPAN(
                {},
                getJOSMurl(issue).map(url =>
                    A(
                        {
                            className: 'link-qa jOSM',
                            href: url,
                            target: '_blank',
                        },
                        'JOSM'
                    )
                )
            ),
            withMapCompleteTheme().map(_theme =>
                SPAN(
                    {},
                    getMapCompleteUrl(issue).map(url =>
                        A(
                            {
                                className: 'link-qa mapComplete',
                                href: url,
                                target: '_blank',
                            },
                            'MapComplete'
                        )
                    )
                )
            ),
        ];
    } else {
        return SPAN({}, 'no coordinates available');
    }
};

const renderGeometryField = (i: Issue) =>
    DIV(
        { className: `issue-field geometry`, key: `issue-field-geometry` },
        DIV({ className: 'issue-field-label' }, tr.qa('geometry')),
        DIV(
            {
                className: 'issue-field-value',
                // onClick: () => centerAndZoomOn(coordToOpenLayerCoord(i.point.coordinates)),
            },
            // DIV({ className: 'value link zoom' }, SPAN({}, tr.qa('zoomToGeom'))),
            DIV(
                { className: 'value link edit-geom-link' },
                renderEditLinkList(i)
            )
        )
    );

const renderOsmRemoteSuccess = (
    rid: OsmResourceId,
    obj: OsmObject,
    issue: Issue
) => {
    const origin = issue.origin
        ? issue.origin
        : getOrigin(issue.issue_type).getOrElse('CREATION_OR_MODIFICATION');
    if (
        origin === 'CHANGE_DETECTION_CREATION' ||
        origin === 'CHANGE_DETECTION_DELETE' ||
        origin === 'CHANGE_DETECTION_MODIFICATION'
    ) {
        return getElement(obj).map(element =>
            getPreviousOsmObjectRemote(rid)
                .chain(remoteToOption)
                .chain(getElement)
                .chain(e => fromNullable(e.tags))
                .fold(
                    DIV(
                        { className: 'issue-field-value' },
                        DIV(
                            { className: 'tags' },
                            // fromNullable(element.tags).map(_t => `Version: ${element.version}`),
                            fromNullable(element.tags).map(
                                mapCollectionC(renderTag)
                            )
                        )
                    ),
                    prevTags => {
                        const newTags = fromNullable(element.tags).getOrElse(
                            {}
                        );
                        // const prevTagsList = mapCollectionC<string, DiffEntry>((k, v) => ({ op: 'none', key: k, value: v }))(prevTags);
                        // const diffList = diffTags(prevTags, newTags);
                        logger('DIFF', prevTags, newTags);
                        return DIV(
                            { className: 'issue-field-value' },
                            tagDiffsTitle(),
                            diffTags(prevTags, newTags).map(diff =>
                                renderDiffedTag(prevTags[diff.key], diff)
                            )
                        );
                    }
                )
        );
    } else {
        return getElement(obj).fold(noView(), element =>
            DIV(
                { className: 'issue-field-value' },
                DIV(
                    { className: 'tags' },
                    fromNullable(element.tags).map(mapCollectionC(renderTag))
                )
            )
        );
    }
};

const renderOsmRemote = (
    rid: OsmResourceId,
    resource: RemoteResource<OsmObject>,
    issue: Issue
) =>
    foldRemote<OsmObject, string, NodeOrOptional>(
        () => DIV({}),
        renderOsmRemoteLoading,
        renderOsmRemoteError,
        obj => renderOsmRemoteSuccess(rid, obj, issue)
    )(resource);

export const renderTagWrapper = (i: Issue) =>
    DIV(
        { className: 'issue-tagGeom-wrapper' },
        renderTagList(i),
        //renderTagActions(i),
        renderGeometryField(i)
    );

logger('loaded');
